import * as React from "react";
const SvgFiRrPriorityArrows = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-priority-arrows_svg__a)">
      <path
        fill="#062147"
        d="M19 0H5C2.243 0 0 2.243 0 5v14c0 2.757 2.243 5 5 5h14c2.757 0 5-2.243 5-5V5c0-2.757-2.243-5-5-5m3 19c0 1.654-1.346 3-3 3H5c-1.654 0-3-1.346-3-3V5c0-1.654 1.346-3 3-3h14c1.654 0 3 1.346 3 3zm-10.5-7.949a1 1 0 0 1-.73-.317L9 8.84v8.161a1 1 0 1 1-2 0V8.794l-1.914 1.914a.999.999 0 1 1-1.414-1.414l2.561-2.561c.467-.467 1.268-.732 1.768-.732s1.3.265 1.768.732l2.463 2.636a1.001 1.001 0 0 1-.731 1.683zm8.828 2.242a1 1 0 0 1 0 1.414l-2.561 2.561c-.467.467-1.268.732-1.768.732s-1.3-.265-1.768-.732l-2.561-2.561a.999.999 0 1 1 1.414-1.414l1.914 1.914V7a1 1 0 1 1 2 0v8.207l1.914-1.914a1 1 0 0 1 1.414 0z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-priority-arrows_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrPriorityArrows;
